import {
  DAMAGED_PACKAGE,
  IN_RECIPIENT,
  LOST_PACKAGE,
  STOLEN_PACKAGE,
  WAITING_DEVOLUTION
} from 'shared/status/status.constants';
import { SECOND_IN_MILLISECONDS } from 'tracker.constants';

const CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION =
  'Algo deu errado e não conseguimos confirmar o endereço.';

const CONFIRM_DELIVERY_ERROR_DESCRIPTION =
  'Algo deu errado e não conseguimos confirmar a entrega.';

const POLLING_TIME = 30 * SECOND_IN_MILLISECONDS;

const SHOULD_NOT_RENDER_CLASSIFICATION_CARD = [
  LOST_PACKAGE,
  STOLEN_PACKAGE,
  DAMAGED_PACKAGE,
  IN_RECIPIENT,
  WAITING_DEVOLUTION
];

const SHOULD_NOT_CONFIRM_ORIGINAL_ADDRESS = SHOULD_NOT_RENDER_CLASSIFICATION_CARD;

export {
  CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION,
  CONFIRM_DELIVERY_ERROR_DESCRIPTION,
  POLLING_TIME,
  SHOULD_NOT_RENDER_CLASSIFICATION_CARD,
  SHOULD_NOT_CONFIRM_ORIGINAL_ADDRESS
};
